import { Component, computed, inject } from '@angular/core';
import { AppService } from '../../services/app.service';

import { TippyDirective } from '@ngneat/helipopper';
import { UtilsService } from '../../services/utils.service';
import { RouterModule } from '@angular/router';
import { AvvvatarsComponent } from '@ngxpert/avvvatars';
import { ConstantsService } from '../../services/constants.service';

@Component({
  selector: 'app-profile-settings',
  imports: [TippyDirective, RouterModule, AvvvatarsComponent],
  templateUrl: './profile-settings.component.html'
})
export class ProfileSettingsComponent {
  private readonly _constants = inject(ConstantsService);
  private readonly _service = inject(AppService);
  private readonly _utilService = inject(UtilsService);
  email = this._service.email;
  icons = this._constants.icons;
  links = computed(() => {
    const icons = this.icons();
    if (!icons) return {};  // fallback while loading
    return {
      businessProfile: {
        name: 'Business Profile',
        link: 'business-profile',
        icon: this._utilService.svgToBase64(icons['business-profile'].icon),
        icon_active: this._utilService.svgToBase64(
          icons['business-profile']['icon-active']
        ),
      },
      billingAndPayment: {
        name: 'Billing & Payments',
        link: 'billing-and-payments',
        icon: this._utilService.svgToBase64(icons['billing-and-payment'].icon),
      }
    }
  });

  openLogoutModal(hide: () => void) { this._service.openLogoutModal(); hide() }
}
